// extracted by mini-css-extract-plugin
module.exports = {"root":"CamerasCell_root__3kd1n"};